import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../core/services/api.service';
import { NotifyService } from '../../core/services/notify.service';

@Component({
  selector: 'app-qr-validate',
  templateUrl: './qr-validate.component.html',
  styleUrls: ['./qr-validate.component.scss']
})


export class QRValidateComponent implements OnInit {

  loading = true;
  error: string | null = null;

  companyData: any = null;
  reservationData: any = null;
  licenseData: any = null;
  status : any 

  type: 'TIN' | 'RESERVATION' | 'LICENSE' | null = null;

  constructor(
    private route: ActivatedRoute,
    private apiService: ApiService,
    private router: Router,
    private notifyService: NotifyService
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const tin = params['tin'];
      const reservation = params['reservation'];
      const license = params['ref'];

      if (tin) {
        this.type = 'TIN';
        this.validateByTin(tin);
      } else if (reservation) {
        this.type = 'RESERVATION';
        this.validateByReservation(reservation);
      }
      else if (license) {
        this.type = 'LICENSE';
        this.validateByLicense(license);
      } else {
        this.loading = false;
        this.notifyService.notifyErrorMessage('Invalid Validation Link', 'The validation link you are trying to access is invalid or expired.');
      }
    });
  }

  private validateByTin(tin: string) {
    this.apiService.companyVerify(tin).subscribe(
      (response: any) => {
        this.loading = false;
        this.companyData = response.data;
        this.status = response.status
      },
      (error: any) => {
        this.loading = false;
        this.notifyService.notifyErrorMessage('Validation Failed', error.error.message);
      }
    );
  }

  private validateByReservation(reservationId: string) {
    this.apiService.nameReservationVerify(reservationId).subscribe(
      (response: any) => {
        this.loading = false;
        this.reservationData = response.data;
        this.status = response.status

      },
      (error: any) => {
        this.loading = false;
        this.notifyService.notifyErrorMessage('Validation Failed', error.error.message);
      }
    );
  }

  private validateByLicense(license: string) {
    this.apiService.licenseVerify(license).subscribe(
      (response: any) => {
        this.loading = false;
        this.licenseData = response.data;
        this.status = response.status

      },
      (error: any) => {
        this.loading = false;
        this.notifyService.notifyErrorMessage('Validation Failed', error.error.message);
      }
    );
  }

  goToWelcomePage() {
    this.router.navigate(['/']);
  }
}


